// Mirror of the server-side QuantityScaler: scales a quantity from base to
// target serves and renders it as a tidy fraction (nearest 1/8).
function gcd(a, b) {
  return b === 0 ? a : gcd(b, a % b)
}

export function toFraction(value) {
  const eighths = Math.round(value * 8)
  const whole = Math.floor(eighths / 8)
  const remainder = eighths % 8
  if (remainder === 0) return String(whole)
  const divisor = gcd(remainder, 8)
  const fraction = `${remainder / divisor}/${8 / divisor}`
  return whole > 0 ? `${whole} ${fraction}` : fraction
}

export function scaleQuantity(quantity, base, target) {
  if (quantity === null || quantity === undefined) return null
  if (!base || !target) return null
  return toFraction((quantity * target) / base)
}

// Mirror of the server-side StepRenderer: resolves {{ing:key|prose}} tokens
// to "prose (scaled quantity unit)".
const TOKEN = /\{\{ing:([a-z0-9\-_]+)\|([^}]*)\}\}/g

export function renderStep(text, ingredientsByKey, base, target) {
  return String(text || "").replace(TOKEN, (_, key, prose) => {
    const ing = ingredientsByKey[key]
    if (!ing) return prose
    const qty = scaleQuantity(ing.quantity, base, target)
    if (qty === null) return prose
    const annotation = [qty, ing.unit].filter(Boolean).join(" ")
    return `${prose} (${annotation})`
  })
}
